// extracted by mini-css-extract-plugin
export var searchIcon = "dq_jN";
export var searchInput = "dq_jM";